import { CustomSelectsOption } from "./CustomSelect";

interface CustomSelectOptionListProps {
    options: CustomSelectsOption[];
    selectedItem: string;
    handleClick: (option: CustomSelectsOption) => void;
    className?: string;
}

const CustomSelectOptionList = ({
    options,
    selectedItem,
    handleClick,
    className = 'absolute w-full rounded-sm shadow-custom-dual bg-primary-100 z-[157202] mt-1 max-w-[250px] max-h-[260px] overflow-y-auto '
}: CustomSelectOptionListProps) => {

    return (
        <div className={`${className}`} style={{ width: '100%' }}>
            <div className='flex flex-col relative z-41'>
                {options.length > 0 ? (
                    options.map((option, index) => (
                        <span
                            key={index}
                            className={`text-llarge py-2 px-3 hover:bg-brand-green-1 cursor-pointer transition-all duration-200 
                                ${selectedItem?.includes(option.value) ? 'bg-brand-green-5' : ''}
                                ${option.disabled ? 'opacity-50 cursor-not-allowed pointer-events-none hover:bg-transparent"' : ''}`}
                            onClick={() => {
                                if (option.disabled) return;
                                handleClick(option);
                            }}
                            role="option"
                            aria-selected={selectedItem === option.value}
                            aria-disabled={option.disabled}
                        >
                            {option.value}
                        </span>
                    ))
                ) : (
                    <span className="text-llarge py-2 px-3 text-gray-500 italic">
                        No hay datos
                    </span>
                )}
            </div>
        </div>
    );
};

export default CustomSelectOptionList;